import { render, staticRenderFns } from "./Ingressi.vue?vue&type=template&id=f13ab474"
import script from "./Ingressi.vue?vue&type=script&lang=js"
export * from "./Ingressi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports